<script lang="ts" setup>
import type { HTMLAttributes } from 'vue'
import { computed } from 'vue'
import { FormControl, FormDescription, FormField, FormItem, FormLabel, FormMessage } from '../../components/ui/form/index'
import { Input } from '../../components/ui/input'

const props = withDefaults(
  defineProps<{
    name: string
    label?: string
    placeholder?: string
    description?: string
    type?: string
    inputmode?: string
    disabled?: boolean
    class?: HTMLAttributes['class']
  }>(),
  {
    type: 'text',
    inputmode: 'text',
  },
)

const cssClass = computed(() => props.class)
</script>

<template>
  <FormField
    v-slot="{ componentField }"
    :name
    :validate-on-change="false"
    :validate-on-input="false"
    :validate-on-mount="false"
    :validate-on-blur="true"
    :validate-on-model-update="false"
  >
    <FormItem :class="cssClass">
      <FormLabel v-if="label || $slots.actions">
        <template v-if="label">
          {{ label }}
        </template>
        <div v-if="$slots.actions" class="ml-auto flex items-center gap-2">
          <slot name="actions" />
        </div>
      </FormLabel>
      <FormControl v-slot="{ formProcessing }">
        <Input :placeholder :inputmode :disabled="disabled || formProcessing" v-bind="componentField" />
      </FormControl>
      <FormDescription v-if="description">
        {{ description }}
      </FormDescription>
      <FormMessage />
    </FormItem>
  </FormField>
</template>
